export const PermissionManagerRoleName = 'N_权限管理员'
export const SuperMangerRoleName = 'N_管理员'
